import NOT_FOUND_PATIENTS from "./not_found.png";
import ADD_PATIENT from "./addPatient.png";
import ARCHIVE_NOT_FOUND from "./archNotFound.svg";
import PILLS_PLACEHOLDER from "./pills_placeholder.jpg";
import NO_HISTORY from "./no_history.svg";
import PAGE_NOT_FOUND from "./page_not_found.svg";
import PILLS_NOT_FOUND from "./pills_not_found.svg";

export const IMAGES = {
  NOT_FOUND_PATIENTS,
  ADD_PATIENT,
  ARCHIVE_NOT_FOUND,
  PILLS_PLACEHOLDER,
  NO_HISTORY,
  PAGE_NOT_FOUND,
  PILLS_NOT_FOUND,
};
